import { render } from "./FavoritesSetup.vue?vue&type=template&id=2ce03074"
import script from "./FavoritesSetup.vue?vue&type=script&lang=js"
export * from "./FavoritesSetup.vue?vue&type=script&lang=js"

import "./FavoritesSetup.vue?vue&type=style&index=0&id=2ce03074&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__